/*
 * Copyright (c) 2021 CalAmp Corp. All Rights Reserved
*/
import {DLSTheme} from '../../types/types';

const sharedStyles = (theme: DLSTheme) => ({
  cardItemRow : {
    '& p' : {
      padding : '0px !important'
    }
  }
});

export default sharedStyles;
